import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { Link } from 'react-router-dom';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
class ListIVR extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ivrlist: [],
			confirmDelete: false,
			selectedBlId: 0,
			loading: false,
			sizePerPage: 10
		}
	}
	componentDidMount() {
		this.getIvrlist();
		const savedSizePerPage = Cookies.get('ivrListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getIvrlist = () => {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;
		Fetcher.get(apiPath + '/api/obd/ivr/list/'+userId)
			.then(res => {
				this.setState({
					ivrlist: res,
					confirmDelete: false,
				})
			})
			.catch(err => { console.log('Error in fetching IVR List', err) });
	}

	confirmDelete = (status, blId) => {
		this.setState({
			confirmDelete: status,
			selectedBlId: blId
		});
	}

	deleteBlacklist = () => {
		const blacklistId = this.state.selectedBlId;
		const data = {

		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/blacklist/' + blacklistId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getBlacklist();
			})
			.catch(err => {
				console.log('Error in Deleting Blacklist Number', err);
			});
	}

	refreshPage = () => {
		this.setState({ loading: true });
		//window.location.reload();
		setTimeout(() => {
			window.location.reload(false);
		}, 500);
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('ivrListsizePerPage', newSizePerPage);
	}

	render() {

		const ivrlist = this.state.ivrlist;
		let columns = '';
		
			columns = [
			{
				dataField: 'ivrId',
				text: 'Ivr Id',
				sort: false,
				//hidden: true
			},
			{
				dataField: 'ivrName',
				text: 'Ivr Name',
				sort: true,
				searchable: true
			},{
				dataField: 'context',
				text: 'Context',
				sort: true,
				searchable: true
			},{
				dataField: 'reqDate',
				text: 'Request Date',
				sort: false,
				searchable: false
			},{
				dataField: 'status',
				text: 'Status',
				sort: false,
				searchable: false
			}];

		const products = Array.isArray(ivrlist) ? ivrlist.map((ivrlist, index) => {
			
			let action = [];
			const id = ivrlist.ivrId;
			//action.push(<a data-tip="Delete Ivrlist" key={`${index}-delete-ivr`} className="delete-bl" onClick={(e) => { this.confirmDelete(true, ivrlist.ivrId) }} href="#"><i className="fa fa-trash"></i></a>)
			action.push(
				<Link data-tip="Edit Ivr" key={`${index}-edit-ivr`} className="nav-link" to={`/ivr/${id}`}><i className="fa fa-edit" title='Edit'></i></Link>
			);
		
			return {
				ivrId: id,
				ivrName: ivrlist.ivrName,
				context: ivrlist.context,
				reqDate: ivrlist.reqDate,
				status: ivrlist.status === 1 ? "Completed":"Pending",
				action: action
			};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'ivrId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: products.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				<Card.Header>IVR List</Card.Header>
				<Card.Body>
					<div className="campaign-list-table-cont">
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (<ToolkitProvider keyField="blacklistId" data={products} columns={columns} search bootstrap4>
									{props => (<div className="">
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
									    <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>	
										<hr />
										<BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
										<PaginationListStandalone {...paginationProps} />
									</div>)}
								</ToolkitProvider>)
							}
						</PaginationProvider>}
					</div>
					<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete Blacklist
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this number from balcklist?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteBlacklist} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
				</Card.Body>
			</Card>
		);
	}
}


export default ListIVR;